module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAYAAABfJS4tAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALFJREFUeNpi+P//PwMJmAmIS4FYhpBaBhIN5v8PAX+B2IKaBoOwIRD/hloQSU2DQVgKiN9CDa+npsEgzAvEN6GGL4KGP1UMBmFWIN4DNfwwELNTy2BYSpkNNfweNIKpYjAMl0IN/wiKA5DA1P/UBxeZGGgFqBgUJehBQY3Im4UUeQLUSm67qJ3ceID4OtTQxdTKIMhZugGIGamRpQ2A+CfU0OhBX2yCwrEciGUJqQUIMADwgpcintaRowAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_jiantou.png
// module id = z7OR
// module chunks = 4